import { gql } from "graphql-request";
export const MISSED_NEWS = gql`
    query missedNews($domainId: Int) {
        allPosts(
            limit: 6
            offset: 54
            published: true
            isDeleted: false
            typeId: 2296
            orderByDesc: createdAt
            domainId: $domainId
        ) {
            title
            image {
                fullPath
                path
            }
            url {
                isActive
                url
                isMain
                main {
                    url
                }
            }
            tags {
                name
            }
        }
    }
`;
